/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;



//////////////////
// WEBPACK FOOTER
// ./~/victory-brush-line/~/lodash/_isPrototype.js
// module id = ./node_modules/victory-brush-line/node_modules/lodash/_isPrototype.js
// module chunks = 1